import React from 'react';
import { Box, List } from '@material-ui/core';
import CommunityListItem from './communityListItem';
import MoengageService from '../../services/moEngageService';
import { getSpentTime } from '../../services/authService';
import { useLastLocation } from 'react-router-last-location';
import { getPreviousLocation, screenNamesSet } from '../../utils/screenUtils';

const CommunityList = ({ communityList, isShowDescription }) => {
  const spentTime = getSpentTime();
  const lastLocation = useLastLocation();
  const sourceName = getPreviousLocation(lastLocation);
  const splitUrl = window.location.pathname.split('/');
  const isSearch = splitUrl[1] === 'search';
  const screenName = isSearch
    ? screenNamesSet.communitySearch
    : screenNamesSet.communitiesList;
  MoengageService.trackScreenOpen(sourceName, screenName, spentTime);

  return (
    <React.Fragment>
      <Box mt={2}>
        <List>
          {communityList &&
            communityList
              .slice(0, 4)
              .map((item, index) => (
                <CommunityListItem
                  isShowDescription={isShowDescription}
                  post={item}
                  key={index}
                />
              ))}
        </List>
      </Box>
    </React.Fragment>
  );
};

export default CommunityList;
